import { Outlet } from "react-router";
import { Center, Container, VStack, HStack, Box } from "@chakra-ui/react";
import LogoImg from '../assets/logo.png'
import { useContext, useState } from "react";
import { Context } from "../store";
import { isInAppBrowser } from "../helpers";
import InAppBrowserWarning from "../components/in-app-browser-warning";

const Layout = () => {
  const { branch_logo, branch_name } = useContext(Context)
  const [inAppBrowser, setInAppBrowser] = useState(isInAppBrowser)

  return (
    <Container>
      <Center>
        <VStack height="100vh" width="sm">
          <Box
            marginTop={10}
          >
            <img
              src={branch_logo || LogoImg}
              style={{ maxHeight: 160, maxWidth: '100%', objectFit: 'contain' }}
              alt={branch_name || 'pass.sagibonus.com'}
              onError={(e) => { (e.currentTarget as HTMLImageElement).src = LogoImg }}
            />
          </Box>
          <HStack paddingTop={5} justifyContent="center" width="100%">
            {inAppBrowser ? <InAppBrowserWarning onContinue={() => setInAppBrowser(false)} /> : <Outlet />}
          </HStack>
        </VStack>
      </Center>

    </Container>
  )
}

export default Layout
